import { render, staticRenderFns } from "./CadastroUsuario.vue?vue&type=template&id=25596b48&scoped=true&"
import script from "./CadastroUsuario.vue?vue&type=script&lang=js&"
export * from "./CadastroUsuario.vue?vue&type=script&lang=js&"
import style0 from "./CadastroUsuario.vue?vue&type=style&index=0&id=25596b48&prod&scoped=true&lang=css&"
import style1 from "./CadastroUsuario.vue?vue&type=style&index=1&id=25596b48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25596b48",
  null
  
)

export default component.exports